import NavBar from '@/components/NavBar/NavBar.vue';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { LOGOUT } from "@/utils/logout.js";

export default {

    name: 'ServiceRules',
    mixins: [LOGOUT],
    pageTitle: 'Service Rules', 
    components: {
        NavBar
    },

  data: () => ({
      service_rules: [],
      questions: [],
      weightQuestion: {},
      showWeightModal: false,
      showThresholdModal: false,
      showConfigModal: false,
      currentLevel: '',
      modalTitle: '',
      editThreshold: {},
      selectedQuestion: {},
      question_id: null,
      service_id: null,
      thresholds: {
          high: { operator: '≥', value: 75 },
          medium: { 
            lowerOperator: '≥', 
            lowerValue: 50,
            upperOperator: '<', 
            upperValue: 75 
          },
          low: { operator: '<', value: 50 }
        },
    }),

    computed: {
      workflow_id() {
        return this.$store.getters.get_workflow_id;
      },

      service_id(){
        return this.$store.getters.get_service_id
      },

      project_id() {
        return this.$store.getters.get_project_id;
      }
    },

    methods: {
      get_service_rules() {
        const TOKEN = localStorage.getItem('token');
        const GET_SERVICE_RULES_API = `${API_BASE_URL}/verify_api/workflow_management_api/get_service_rules/${this.service_id}/${this.workflow_id}`;

        $.ajax({
          url: GET_SERVICE_RULES_API,
          method: 'GET',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          beforeSend: () => {
            this.loading = true;
          },
          success: (response) => {

            this.service_rules = response.service_questions;
            this.questions = response.service_questions;

          },
          error: () => {
            this.loading = false;
            let error_message = 'Error Getting Service rules';
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error_message,
              confirmButtonText: 'OK'
            });
          }
        });

      },

      get_rules() {
      const TOKEN = localStorage.getItem('token');
      const GET_RULES_API = `${API_BASE_URL}/verify_api/form_management_api/get_service_question_rules_api/${this.service_id}/${this.question_id}/${this.workflow_id}/${this.project_id}`;

      $.ajax({
        url: GET_RULES_API,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
          Swal.fire({
            text: 'Loading rules...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        },
        success: (response) => {
          Swal.close();
          
          if (response.status === 'success' && response.data && response.data.rules) {
            const formattedRules = response.data.rules.map(rule => {
              const formattedRule = {
                severity: rule.severity_level ? rule.severity_level.toLowerCase() : 'medium',
                operator: rule.operator,
                score: rule.score
              };
              
              if (this.selectedQuestion.question_type === 'Selection' || 
                  this.selectedQuestion.question_type === 'Multi Selection' || 
                  this.selectedQuestion.question_type === 'Checkbox') {
                
                const matchingOption = this.getAvailableOptions().find(opt => {
                  return (opt.id && String(opt.id) === String(rule.value)) || 
                        (opt.option && opt.option === rule.value) ||
                        (typeof rule.value === 'object' && rule.value && rule.value.id && 
                        opt.id && String(opt.id) === String(rule.value.id));
                });
                
                if (matchingOption) {
                  formattedRule.value = matchingOption;
                } else {
                  formattedRule.value = {
                    id: typeof rule.value === 'object' ? rule.value.id : rule.value,
                    option: typeof rule.value === 'object' ? rule.value.option : rule.value
                  };
                }
              } else if (this.selectedQuestion.question_type === 'Date') {
                
                if (rule.operator === 'Today') {
                  formattedRule.dateType = 'current';
                  formattedRule.value = '';
                } else if (
                  (typeof rule.value === 'number') || 
                  (typeof rule.value === 'string' && !isNaN(rule.value) && rule.value.trim() !== '' && !rule.value.includes('-'))
                ) {
                  formattedRule.dateType = 'number';
                  formattedRule.daysValue = parseInt(rule.value);
                  formattedRule.value = '';
                } else if (rule.value && (
                  (typeof rule.value === 'string' && 
                  (rule.value.includes('-') || rule.value.includes('/') || rule.value.includes('.')))
                )) {
                  formattedRule.dateType = 'calendar';
                  
                  try {
                    const dateObj = new Date(rule.value);
                    if (!isNaN(dateObj.getTime())) {
                      const year = dateObj.getFullYear();
                      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                      const day = String(dateObj.getDate()).padStart(2, '0');
                      formattedRule.value = `${year}-${month}-${day}`;
                    } else {
                      formattedRule.value = rule.value;
                    }
                  } catch (e) {
                    formattedRule.value = rule.value;
                  }
                } else {
                  formattedRule.dateType = 'calendar';
                  formattedRule.value = '';
                }
              } else if (this.selectedQuestion.question_type === 'File') {
                formattedRule.value = rule.value;
                formattedRule.fileProperty = rule.operator.includes('extension') || 
                                            (typeof rule.value === 'string' && rule.value.includes('.')) 
                                            ? 'extension' : 'size';
              } else if (this.selectedQuestion.question_type === 'Boolean') {
                formattedRule.value = String(rule.value).toLowerCase();
              } else if (this.selectedQuestion.question_type === 'Number') {
                formattedRule.value = typeof rule.value === 'string' ? parseFloat(rule.value) : rule.value;
              } else {
                formattedRule.value = rule.value;
              }
              
              return formattedRule;
            });
            
            this.selectedQuestion.rules = formattedRules;
            const questionIndex = this.questions.findIndex(q => q.id === this.selectedQuestion.id);
            if (questionIndex !== -1) {
              this.questions[questionIndex].rules = formattedRules;
            }
            
            this.calculateWeightPercentages();
          } else {
            this.selectedQuestion.rules = [];
            
            const questionIndex = this.questions.findIndex(q => q.id === this.selectedQuestion.id);
            if (questionIndex !== -1) {
              this.questions[questionIndex].rules = [];
            }
          }
        },
        error: () => {
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to load rules',
            confirmButtonText: 'OK'
          });
          
          this.selectedQuestion.rules = [];
        }
      });
      },
            
      save_rules() {
        const TOKEN = localStorage.getItem('token');
        const SAVE_RULES_API = `${API_BASE_URL}/verify_api/form_management_api/save_service_question_rules_api/`;
        
        const simplifiedRules = this.selectedQuestion.rules.map(rule => ({
          operator: rule.operator,
          score: rule.score,
          value: rule.value,
          severity_level: rule.severity
        }));

        const FORM_DATA = {
          question_id: this.selectedQuestion.id,
          service_id: this.service_id,
          workflow_id: this.workflow_id,
          project_id: this.project_id,
          rules: simplifiedRules
        };
        
        $.ajax({
          url: SAVE_RULES_API,
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(FORM_DATA),
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          beforeSend: () => {
            Swal.fire({
              text: 'Saving rules...',
              allowEscapeKey: false,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });
          },
          success: () => {
            
            Swal.close();
            
            const questionIndex = this.questions.findIndex(q => q.id === this.selectedQuestion.id);
            if (questionIndex !== -1) {
              this.questions[questionIndex].rules = [...simplifiedRules];
            }
            
            this.calculateWeightPercentages();
            this.closeConfigModal();
            
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Rules saved successfully',
              timer: 1500
            });
          },
          error: () => {
            Swal.close();
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to save rules',
              confirmButtonText: 'OK'
            });
          }
        });
      },

      saveScore() {
        const TOKEN = localStorage.getItem('token');
        const SET_SCORE_API = `${API_BASE_URL}/verify_api/form_management_api/set_service_question_score_api/`;
        
        const weight = parseInt(this.weightQuestion.weight) || 0;
        
        const FORM_DATA = {
          question_id: this.weightQuestion.id,
          service_id: this.service_id,
          workflow_id: this.workflow_id,
          project_id: this.project_id,
          score: weight
        };
        
        $.ajax({
          url: SET_SCORE_API,
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(FORM_DATA),
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          beforeSend: () => {
            Swal.fire({
              text: 'Saving score...',
              allowEscapeKey: false,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });
          },
          success: () => {
            
            Swal.close();
            
            const index = this.questions.findIndex(q => q.id === this.weightQuestion.id);
            if (index !== -1) {
              this.questions[index].weight = weight;
              this.calculateWeightPercentages();
            }
            
            this.closeWeightModal();
            
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Score saved successfully',
              timer: 1500
            });
          },
          error: () => {
            Swal.close();
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to save score',
              confirmButtonText: 'OK'
            });
          }
        });
      },

      saveThreshold() {
        if (this.currentLevel === 'high' || this.currentLevel === 'low') {
          if (this.editThreshold.value < 0 || this.editThreshold.value > 100) {
            this.validationError = "Threshold value must be between 0 and 100";
            return;
          }
        } else if (this.currentLevel === 'medium') {
          if (this.editThreshold.lowerValue < 0 || this.editThreshold.lowerValue > 100 ||
            this.editThreshold.upperValue < 0 || this.editThreshold.upperValue > 100) {
            this.validationError = "Threshold values must be between 0 and 100";
            return;
          }
          
          if (this.editThreshold.upperValue <= this.editThreshold.lowerValue) {
            this.validationError = `Medium's upper threshold (${this.editThreshold.upperValue}%) must be greater than its lower threshold (${this.editThreshold.lowerValue}%)`;
            return;
          }
        }
        
        if (this.currentLevel === 'high') {
          this.thresholds.medium.upperValue = this.editThreshold.value;
          this.thresholds.high = JSON.parse(JSON.stringify(this.editThreshold));
        } 
        else if (this.currentLevel === 'medium') {
          this.thresholds.medium = JSON.parse(JSON.stringify(this.editThreshold));
          
          this.thresholds.high.value = this.editThreshold.upperValue;
          
          this.thresholds.low.value = this.editThreshold.lowerValue;
        }
        else if (this.currentLevel === 'low') {
          this.thresholds.medium.lowerValue = this.editThreshold.value;
          this.thresholds.low = JSON.parse(JSON.stringify(this.editThreshold));
        }
        
        const TOKEN = localStorage.getItem('token');
        const SAVE_THRESHOLDS_API = `${API_BASE_URL}/verify_api/form_management_api/save_project_service_thresholds_api/`;
        
        const FORM_DATA = {
          service_id: this.service_id,
          workflow_id: this.workflow_id,
          project_id: this.project_id,
          thresholds: {
            high: {
              value: this.thresholds.high.value,
              operator: this.thresholds.high.operator
            },
            medium: {
              lowerValue: this.thresholds.medium.lowerValue,
              lowerOperator: this.thresholds.medium.lowerOperator,
              upperValue: this.thresholds.medium.upperValue,
              upperOperator: this.thresholds.medium.upperOperator
            },
            low: {
              value: this.thresholds.low.value,
              operator: this.thresholds.low.operator
            }
          }
        };
        
        $.ajax({
          url: SAVE_THRESHOLDS_API,
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(FORM_DATA),
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          beforeSend: () => {
            Swal.fire({
              text: 'Saving thresholds...',
              allowEscapeKey: false,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });
          },
          success: () => {
            Swal.close();
            this.closeThresholdModal();
            
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Thresholds saved successfully',
              timer: 1500
            });
          },
          error: () => {
            Swal.close();
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to save thresholds',
              confirmButtonText: 'OK'
            });
          }
        });
      },

      calculateWeightPercentages() {
        const checkedQuestions = this.questions.filter(q => 
          q.is_active && q.is_checked && (parseInt(q.weight) > 0)
        );
        
        const totalWeight = checkedQuestions.reduce((sum, q) => 
          sum + parseInt(q.weight || 0), 0
        );
        
        this.totalWeight = totalWeight > 0 ? totalWeight : 1; // Avoid division by zero
      },

      getWeightPercentage(questionId) {
          const checkedQuestions = this.questions.filter(q => q.is_active && parseInt(q.weight || 0) > 0);
          
          if (checkedQuestions.length === 0) return 0;
          
          const totalWeight = checkedQuestions.reduce((sum, q) => sum + parseInt(q.weight || 0), 0);
          
          if (totalWeight === 0) return 0;
          
          const question = this.questions.find(q => q.id === questionId);
          if (!question || !question.weight) return 0;
          
          return (parseInt(question.weight) / totalWeight * 100);
      },

      get_threshold() {
        const TOKEN = localStorage.getItem('token');
        const GET_SERVICE_THRESHOLD_API = `${API_BASE_URL}/verify_api/form_management_api/get_project_service_thresholds_api/${this.service_id}/${this.workflow_id}/${this.project_id}`;
        
        $.ajax({
          url: GET_SERVICE_THRESHOLD_API,
          method: 'GET',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          beforeSend: () => {
            this.loading = true;
          },
          success: (response) => {
            if (response.redirect) {
              this.logout();
              return;
            }
            
            if (response.status === 'success' && response.data) {
              
              this.thresholds = response.data;
              
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Invalid response format from server',
                confirmButtonText: 'OK'
              });
            }
            
            this.loading = false;
          },
          error: (xhr) => {
            this.loading = false;
            let error_message = 'Error Getting Service Threshold';
            
            if (xhr.responseJSON && xhr.responseJSON.message) {
              error_message = xhr.responseJSON.message;
            }
            
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error_message,
              confirmButtonText: 'OK'
            });
          }
        });
      },

      getTotalWeight() {
        let total = 0;
        this.questions.forEach(question => {
          if (question.is_active && question.weight) {
            total += parseInt(question.weight);
          }
        });
        return total;
      },

      validateThresholds() {
        this.thresholdError = null;
        
        if (this.currentLevel === 'high' || this.currentLevel === 'low') {
          if (this.editThreshold.value > 100) {
            this.editThreshold.value = 100;
          } else if (this.editThreshold.value < 0) {
            this.editThreshold.value = 0;
          }
        } else if (this.currentLevel === 'medium') {
          if (this.editThreshold.lowerValue > 100) {
            this.editThreshold.lowerValue = 100;
          } else if (this.editThreshold.lowerValue < 0) {
            this.editThreshold.lowerValue = 0;
          }
          
          if (this.editThreshold.upperValue > 100) {
            this.editThreshold.upperValue = 100;
          } else if (this.editThreshold.upperValue < 0) {
            this.editThreshold.upperValue = 0;
          }
        }
        
        if (this.currentLevel === 'medium') {
          const mediumLowerValue = this.editThreshold.lowerValue;
          const mediumUpperValue = this.editThreshold.upperValue;
          
          if (mediumLowerValue >= mediumUpperValue) {
            this.thresholdError = `Medium lower threshold (${mediumLowerValue}%) must be less than upper threshold (${mediumUpperValue}%)`;
            return;
          }
          if (this.thresholds.low && this.thresholds.low.value >= mediumLowerValue) {
            const newLowValue = Math.max(0, mediumLowerValue - 1);
            this.thresholds.low.value = newLowValue;
            this.thresholds.low.operator = '<'; // Ensure proper inequality
          }
          
          if (this.thresholds.high && this.thresholds.high.value <= mediumUpperValue) {
            const newHighValue = Math.min(100, mediumUpperValue + 1);
            this.thresholds.high.value = newHighValue;
            this.thresholds.high.operator = '≥'; // Ensure proper inequality
          }
          
        } else if (this.currentLevel === 'high') {
          const highValue = this.editThreshold.value;
          
          if (this.thresholds.medium && this.thresholds.medium.upperValue >= highValue) {
            const newMediumUpper = Math.max(0, highValue - 1);
            this.thresholds.medium.upperValue = newMediumUpper;
            this.thresholds.medium.upperOperator = '<'; // Ensure proper inequality
            
            if (this.thresholds.medium.lowerValue >= newMediumUpper) {
              this.thresholds.medium.lowerValue = Math.max(0, newMediumUpper - 1);
            }
          }
          
        } else if (this.currentLevel === 'low') {
          const lowValue = this.editThreshold.value;
          
          if (this.thresholds.medium && this.thresholds.medium.lowerValue <= lowValue) {
            const newMediumLower = Math.min(100, lowValue + 1);
            this.thresholds.medium.lowerValue = newMediumLower;
            this.thresholds.medium.lowerOperator = '≥';
            
            if (this.thresholds.medium.upperValue <= newMediumLower) {
              this.thresholds.medium.upperValue = Math.min(100, newMediumLower + 1);
            }
          }
        }
        
        if (this.currentLevel === 'medium') {
          const mediumLowerValue = this.editThreshold.lowerValue;
          const mediumUpperValue = this.editThreshold.upperValue;
          
          if (mediumLowerValue >= mediumUpperValue) {
            this.thresholdError = `Medium lower threshold (${mediumLowerValue}%) must be less than upper threshold (${mediumUpperValue}%)`;
          }
        }
      },

      validateThresholdsValidation(event, modelName) {
        const target = event.target;
        let value = parseFloat(target.value);

        const min = parseFloat(target.min) || 0;
        const max = parseFloat(target.max) || 100;

        if (isNaN(value)) {
          value = min;
        } else {
          value = Math.min(Math.max(value, min), max);
        }

        this[modelName].value = value;
        
        this.validateThresholds();
      },

      handleButtonClick(question) {
        if (!question.weight || question.weight == 0) {
          question.showTooltip = true;
          setTimeout(() => {
            question.showTooltip = false;
          }, 3000);
          return;
        }
        
        this.question_id = question.id;
        this.openConfigModal(question);
      },

      openConfigModal(question) {
        this.selectedQuestion = JSON.parse(JSON.stringify(question)); // Deep clone the question
        this.question_id = question.id;
        this.selectedQuestion.rules = [];
        
        this.get_rules();
        
        this.showConfigModal = true;
      },

      initDataTable() {
        this.$nextTick(() => {
          if ($.fn.dataTable.isDataTable('#question_table')) {
            $('#question_table').DataTable().destroy();
          }
          $('#question_table').DataTable({
            responsive: true
          });
        });

        this.$nextTick(() => {
          if ($.fn.dataTable.isDataTable('#file_question_table')) {
            $('#file_question_table').DataTable().destroy();
          }
          $('#file_question_table').DataTable({
            responsive: true
          });
        });
      },

      isOptionDisabled(option, currentIndex, isMulti = false) {
        if (isMulti) return false;
        
        const isUsed = this.selectedQuestion.rules.some((rule, idx) => {
          if (idx === currentIndex) return false; // Skip current rule
          
          if (rule.value && rule.value.id === option.id) return true;
          
          if (rule.multiValues && rule.multiValues.some(val => val.id === option.id)) return true;
          
          return false;
        });
        
        return isUsed;
      },

      add_new_rule() {
        if (this.isMaxRulesReached()) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Maximum number of rules reached for this question type.',
            confirmButtonText: 'OK'
          });
          return;
        }

        const usedOptions = this.selectedQuestion.rules
          ? this.selectedQuestion.rules.map(rule => rule.value).filter(val => val !== null && val !== undefined)
          : [];

        const allOptions = this.getAvailableOptions();
        
        const unselectedOption = allOptions.find(option => {
          return !usedOptions.some(usedOption => {
            if (typeof usedOption === 'object' && usedOption !== null) {
              return usedOption.id === option.id;
            }
            return usedOption === option.id || usedOption === option.option;
          });
        });

        let newRule = {
          severity: 'medium',
          operator: '==',
          message: '',
          score: 0,
          value: null
        };

        switch (this.selectedQuestion.question_type) {
          case 'Number':
            newRule.operator = '==';
            newRule.value = 0;
            break;

          case 'Date':
            newRule.operator = '==';
            newRule.dateType = 'calendar';
            newRule.value = '';
            break;

          case 'Selection':
          case 'Choice':
          case 'Checkbox':
          case 'Multi Selection':
            newRule.value = unselectedOption || (allOptions.length > 0 ? allOptions[0] : null);
            break;

          case 'Boolean':
            newRule.operator = 'is_true';
            newRule.value = 'true';
            break;

          case 'File':
            newRule.operator = 'contains';
            newRule.fileProperty = 'extension';
            newRule.value = 'pdf';
            break;

          default:
            newRule.operator = 'contains';
            newRule.value = '';
        }

        this.selectedQuestion.rules.push(newRule);
      },

      clampScore(rule) {
        if (!this.selectedQuestion?.weight) {
          console.error("selectedQuestion.weight is undefined");
          return;
        }
    
        if (isNaN(rule.score)) {
          rule.score = 0;
        }
    
        rule.score = Math.max(
          0,
          Math.min(rule.score, this.selectedQuestion.weight)
        );
      },

      isMaxRulesReached() {
        if ((this.selectedQuestion.question_type === 'Selection' || 
            this.selectedQuestion.question_type === 'Choice' || 
            this.selectedQuestion.question_type === 'Checkbox') && 
            this.selectedQuestion.options) {
          return this.selectedQuestion.rules.length >= this.selectedQuestion.options.length;
        }
        
        if (this.selectedQuestion.question_type === 'Boolean') {
          return this.selectedQuestion.rules.length >= 2;
        }
        
        if (this.selectedQuestion.question_type === 'File') {
          return this.selectedQuestion.rules.length >= 2;
        }
        
        return this.selectedQuestion.rules.length >= 5;
      },

      getAvailableOptions() {
        if (!this.selectedQuestion.options || !Array.isArray(this.selectedQuestion.options)) {
          return [];
        }
        
        return this.selectedQuestion.options.map(opt => {
          if (typeof opt === 'string') {
            return { id: opt, option: opt };
          } else if (typeof opt === 'object' && opt !== null) {
            return {
              id: opt.id || opt.value || opt.option,
              option: opt.option || opt.label || opt.text || String(opt.id)
            };
          }
          return opt;
        });
      },

      showNumericOperators() {
        return this.selectedQuestion.question_type === 'Number';
      },

      showTextOperators() {
        return this.selectedQuestion.question_type === 'Text' || 
              this.selectedQuestion.question_type === 'Textarea';
      },

      showSelectOperators() {
        return this.selectedQuestion.question_type === 'Selection' || 
              this.selectedQuestion.question_type === 'Multi Selection' || 
              this.selectedQuestion.question_type === 'Checkbox';
      },
      
      showBooleanOperators() {
        return this.selectedQuestion.question_type === 'Boolean';
      },
      
      showDateOperators() {
        return this.selectedQuestion.question_type === 'Date';
      },

      configQuestion(questionId) {
        const question = this.questions.find(q => q.id === questionId);
        
        if (question) {
          if (!question.rules) {
            question.rules = [];
          }
          
          this.selectedQuestion = JSON.parse(JSON.stringify(question));
          
          this.showConfigModal = true;
        }

        this.calculateWeightPercentages();
      },
      
      removeRule(index) {
        this.selectedQuestion.rules.splice(index, 1);
      },
      
      closeConfigModal() {
        this.showConfigModal = false;
      },

      openWeightModal(question_id) {
        const question = this.questions.find(q => q.id === question_id);
        if (question) {
          this.weightQuestion = JSON.parse(JSON.stringify(question));
          this.showWeightModal = true;
        }
      },
      
      closeWeightModal() {
        this.showWeightModal = false;
        this.weightQuestion = {};
      },

      openModal(level) {
        this.currentLevel = level;
        
        this.modalTitle = `Edit ${level.charAt(0).toUpperCase() + level.slice(1)} Severity Threshold`;
        
        this.editThreshold = JSON.parse(JSON.stringify(this.thresholds[level]));
        this.validationError = null;
        
        this.showThresholdModal = true;
    },

    closeThresholdModal() {
      this.showThresholdModal = false;
      this.validationError = null;
    },

      route_to_workflow_services() {
          this.$router.push({ name: 'workflow_services' });
      },

      getColorForThreshold(level) {
        if (level === 'high') {
          const value = this.thresholds.high.value;
          return `rgba(${Math.min(255, 200 + (value/100) * 55)}, ${Math.max(0, 70 - (value/100) * 70)}, ${Math.max(0, 70 - (value/100) * 70)}, 1)`;
        } else if (level === 'medium') {
          const lowerValue = this.thresholds.medium.lowerValue;
          const upperValue = this.thresholds.medium.upperValue;
          const midPoint = (lowerValue + upperValue) / 2;
          return `rgba(${Math.min(255, 200 + (midPoint/100) * 55)}, ${Math.min(255, 150 + (midPoint/100) * 105)}, 0, 1)`;
        } else if (level === 'low') {
          const value = this.thresholds.low.value;
          return `rgba(${Math.max(0, 100 - (value/100) * 100)}, ${Math.min(255, 180 + (value/100) * 75)}, ${Math.max(0, 60 - (value/100) * 60)}, 1)`;
        }
        return '';
      }
    },

    mounted() {
      if (!validateToken(this.$router)) {
        return;
    }
      this.service_id = this.$route.params.service_id;
      this.get_service_rules();
      this.calculateWeightPercentages();
      this.get_threshold();

    },
  };
